import React from 'react';
import { Grid, Segment, Divider, Item, Header, Form } from "semantic-ui-react"
import { Link } from "react-router-dom";
import {helpLoginURL} from "../../shared/urls/clientapi";
import {callService, POST} from "../../shared/serviceInvoker";
import MessageSuccess from "../../shared/components/MessageSuccess";
import MessageError from "../../shared/components/MessageError";
import AllRightsReserved from "../../shared/components/AllRightsReserved";
import CompanyLogo from "../../shared/components/CompanyLogo";
import ContactUs from "../../shared/components/ContactUs";
import ReactGA from 'react-ga';
import { trackEvent } from '../../shared/tracking';

export default class PasswordHelp extends React.Component {
  constructor(props) {
    super(props);

    this.error = props.location.state ? props.location.state.error : false;

    this.state = {
      email: '',
      emailValid: false,
      formValid: false,
      showSuccessMessage: false,
      showErrorMessage: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateField = this.validateField.bind(this);
    this.validateForm = this.validateForm.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState(
        {[name]: value},
        () => {this.validateField(name, value)}
    );
  }

  validateField(fieldName, value) {
      let emailValid = this.state.emailValid;
      switch(fieldName) {
        case 'email':
          emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
          break;
        default:
          break;
      }
      this.setState({emailValid: emailValid}, this.validateForm)
  }

  validateForm() {
    this.setState({formValid: this.state.emailValid})
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const {email} = this.state;

    let bodyFormData = new FormData();
    bodyFormData.append('email', email);

    callService(
      POST,
      helpLoginURL,
      bodyFormData,
      response => {
        this.setState({ showSuccessMessage: true, showErrorMessage: false });
        ReactGA.event({
          category: 'Profile',
          action: 'Password Reset Requested',
        });
        trackEvent('Profile', 'Password Reset Requested');
      },
      error => {
        this.setState({ showErrorMessage: true, showSuccessMessage: false });
      }
    );
  };

  render() {
    const { email } = this.state;

    return (
      <div className='form'>
        <style>{`
          body > div,
          body > div > div,
          body > div > div > div.form {
            height: 100%;
            background-color: #f2f2f2;
          }
        `}</style>
        <Grid textAlign='center' style={{ height: '100%' }} verticalAlign='middle'>
          <Grid.Column style={{ maxWidth: 450 }}>
            <CompanyLogo linkTo='/login'/>
            <Segment>
              <Header as='h1'>Sign In Help</Header>
              <Header as='h4'>Having sign in trouble or here for the first time? We'll get you back on track quickly.</Header>
              {
                this.error && !this.state.showSuccessMessage ?
                  <p>
                    <MessageError message='Sorry, this link has expired or is not valid. Please enter
                                        your email address below to create a new link.' />
                  </p>                      
                :
                  null
              }
                
              <Form onSubmit={this.handleSubmit}>
                {
                  !this.state.showSuccessMessage ?
                  <div>
                    <Item style={{ textAlign: 'left' }} >Enter your email address</Item>
                    <Form.Input
                      fluid icon='mail'
                      iconPosition='left'
                      placeholder='Email address'
                      name='email'
                      required value={email}
                      onChange={this.handleInputChange} />
                    <Form.Button color='blue' fluid size='large' icon='send' content='Continue' disabled={!this.state.formValid} />
                    <Item as={Link} to='/login'>Return to Sign In page</Item>
                  </div>
                  : null
                }

                {
                  this.state.showSuccessMessage ?
                    <div>
                      <MessageSuccess message="Thanks! Further information will be sent to your email address. 
                      (It may take a few minutes to make it's way to you. Be sure to check your spam or junk folder as well.)" />
                      <br />
                      <Item as={Link} to='/login'>Return to Sign In page</Item>
                    </div>
                  :
                    null
                }

                {
                  this.state.showErrorMessage ?
                    <MessageError message="An unexpected error occurred while sending the request. Please try again later." />
                  :
                    null
                }
                <Divider />
                <Item>
                  Email trouble?&nbsp;<ContactUs />
                </Item>  
              </Form>              
            </Segment>
            <Divider hidden />
            <AllRightsReserved />
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/PasswordHelp/index.js